<div
  class="container"
  [ngClass]="['variant-' + variant, hasChips ? 'with-chips' : 'without-chips']"
>
  <div class="content">
    <div class="info-section">
      <div class="icon" [class.spinner]="variant === 'spinner'">
        <img [src]="iconPath" alt="" />
      </div>
      <div class="text-content">
        <p class="title">{{ title }}</p>
        <p class="description" *ngIf="description">{{ description }}</p>
        <div class="chips" *ngIf="hasChips">
          <span
            class="chip"
            *ngFor="let chip of chips; trackBy: trackByChipLabel"
            [ngClass]="'marker-' + chip.marker"
          >
            <img class="chip-glyph" *ngIf="chip.marker === 'done'" [src]="tickPath" alt="" />
            <img
              class="chip-glyph"
              *ngIf="chip.marker === 'waiting'"
              [src]="chipClockPath"
              alt=""
            />
            <img
              class="chip-glyph"
              *ngIf="chip.marker === 'locked'"
              [src]="chipLockPath"
              alt=""
            />
            <span
              class="chip-spot"
              *ngIf="
                chip.marker !== 'done' &&
                chip.marker !== 'waiting' &&
                chip.marker !== 'locked'
              "
            ></span>
            <span class="chip-label">{{ chip.label }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="actions" *ngIf="buttonLabel">
      <lib-ui-button
        [variant]="buttonVariant"
        size="l"
        [fullWidth]="!!secondaryButtonLabel"
        (click)="action.emit()"
        [label]="buttonLabel"
      ></lib-ui-button>
      <lib-ui-button
        *ngIf="secondaryButtonLabel"
        class="secondary-button"
        variant="outline"
        size="l"
        [fullWidth]="true"
        (click)="secondaryAction.emit()"
        [label]="secondaryButtonLabel"
      ></lib-ui-button>
    </div>
    <button
      class="dismiss"
      *ngIf="dismissible"
      type="button"
      aria-label="Cerrar"
      (click)="dismiss.emit()"
    >
      <img [src]="closePath" alt="" />
    </button>
  </div>
</div>
